import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkbox-on",
  "use": "icon-checkbox-on-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-checkbox-on\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect stroke=\"currentColor\" fill=\"currentColor\" x=\".5\" y=\".5\" width=\"21\" height=\"21\" rx=\"2\" />\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M15.21 7.345l1.093 1.094-6.364 6.364-4.242-4.242L6.757 9.5l3.149 3.149z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol